class HCPNotice {
	constructor() {
		this.extModal = document.getElementById('hcp-notice');
		this.continueButton = this.extModal.querySelector('.continueExt');
		this.closeButton = this.extModal.querySelector('.c-modal__inner_close');

		this.closeButton.addEventListener('click', this.closeModal);
		document.addEventListener('keydown', this.handleKeyDown);

		this.noticeCookie = this.getCookie('emHCPnotice');

		if (!this.noticeCookie) {
			this.displayModal();
		}
	}

	setCookie = (name, value, days) => {
		let expires = '';

		if (days) {
			let date = new Date();
			date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
			expires = "; expires=" + date.toUTCString();
		}

		document.cookie = name + "=" + value + expires + "; path=/";
	}

	getCookie = (name) => {
		let cookieName = name + "=";
		const cookieArray = document.cookie.split(';');

		for ( var i = 0; i < cookieArray.length; i++) {
			var cookie = cookieArray[i];
			while (cookie.charAt(0) === ' ' ) {
				cookie = cookie.substring(1, cookie.length);
			}

			if (cookie.indexOf(cookieName) == 0) {
				return cookie.substring(cookieName.length, cookie.length);
			}
		}

		return null;
	}

	handleKeyDown = (e) => {
		if (this.extModal.classList.contains('is-open')) {
			if (e.key !== 'Escape') {
				return;
			}

			this.extModal.classList.remove('is-open');

			if (!this.noticeCookie) {
				this.setCookie('emHCPnotice', true, 30);
			}
		}
	}

	displayModal = () => {
		this.extModal.classList.add('is-open');

		const continueButton = this.extModal.querySelector('.continueExt');
		continueButton.addEventListener('click', (e) => {
			e.preventDefault();
			this.setCookie('emHCPnotice', true, 30);
			this.extModal.classList.remove('is-open');
		});
	}

	closeModal = () => {
		this.extModal.classList.remove('is-open');

		if (!this.noticeCookie) {
			this.setCookie('emHCPnotice', true, 30);
		}
	}
}

export function initHCPNotice() {
	embark.components.HCPNotice = new HCPNotice();
}

initHCPNotice();
